export const STATUS = {
  PEN: { variant: 'outline-dark', text: 'PENDING' },
  APP: { variant: 'outline-success', text: 'APPROVED' },
  REJ: { variant: 'outline-danger', text: 'REJECTED' },
  REV: { variant: 'outline-warning', text: 'REVISE' },
  VER: { variant: 'outline-success', text: 'VERIFIED' },
};
